import getValidateStatusInstance, { TGetValidateStatus, TGetValidateStatusInstance } from './getValidateStatusInstance'

export type { TGetValidateStatus, TGetValidateStatusInstance }
export default getValidateStatusInstance
